import React from "react";
// import "./";
import EducationBanner from "../Components/EducationPageComponents/EducationBanner";
import EducationSummary from "../Components/EducationPageComponents/EducationSummary";
import { Helmet } from "react-helmet";
const Education = () => {
  return (
    <>
      <Helmet>
        {/* Meta tags */}
        <title>4Cs Education of Diamonds | Sreehari Diamond Laboratory </title>
        <meta
          name="description"
          content="Learn about the 4Cs of diamonds - Cut, Color, Clarity, and Carat. Enhance your knowledge with expert gemological education and insights."
        />
        <meta
          name="keywords"
          content="lab grown diamond certification, best diamond certification in india, Gemstone Identification Lab, Diamond, Gemological Laboratory, Diamond Testing Lab, Diamond Sealing service, Diamond Hologram Stickers, Hologram Stickers for Certificates, Best diamond online services, 4 cs' of diamonds, 4cs education of diamond"
        />
        {/* OG tags */}
        <meta
          property="og:title"
          content="4Cs Education of Diamonds | Sreehari Diamond Laboratory"
        />
        <meta
          property="og:description"
          content="Learn about the 4Cs of diamonds - Cut, Color, Clarity, and Carat. Enhance your knowledge with expert gemological education and insights."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://sreeharidiamondlab.com/4cs-of-diamonds"
        />
        <meta
          property="og:image"
          content="https://sreeharidiamondlab.com/static/media/diamond_Cut_1.687346b94ca0fa2d6c72.webp"
        />
        <meta property="og:site_name" content="sreehari diamond laboratory" />
        {/* Twitter tags */}
        <meta
          name="twitter:title"
          content="4Cs Education of Diamonds | Sreehari Diamond Laboratory"
        />
        <meta
          name="twitter:description"
          content="Learn about the 4Cs of diamonds - Cut, Color, Clarity, and Carat. Enhance your knowledge with expert gemological education and insights."
        />
        <meta
          name="twitter:image"
          content="https://sreeharidiamondlab.com/static/media/diamond_Cut_1.687346b94ca0fa2d6c72.webp"
        />
        <meta name="twitter:site" content="sreehari diamond laboratory" />
        <link
          rel="canonical"
          href="https://sreeharidiamondlab.com/4cs-of-diamonds"
        />{" "}
      </Helmet>
      <div>
        <EducationBanner />
        <EducationSummary />
      </div>
    </>
  );
};

export default Education;
